// Which page each menu name opens in the seller portal. Shared by the top navigation and the guided tour,
// so both always agree. The menus themselves come from the backend at login (user.menus).

export const ROUTES = {
  Dashboard: '/dashboard', Products: null, ProductManagement: '/products', VendorProductRequest: '/productrequestlist', Categories: '/categories', Expired: '/expired',
  UserManagement: null, Customer: '/customermanagement', Sellers: '/vendormanagement', Hr: '/hrmanagement', Users: '/usermangement', Seller: '/seller', Operations: null,
  Orders: '/orders', Warehouse: '/warehouse', Coupons: '/coupons', 'Online Orders': '/orders', Logs: null, MobileContent: '/mobilecontent', AppPolicy: '/apppolicy', FAQs: '/faqs',
  ActivityLog: '/activitylog', LoginLogs: '/loginlogs', Account: null, Profile: '/profile', Settings: null, Rewards: '/rewards', MenuConfiguration: '/settings',
  'Shipping & Payment Config': '/shippingpaymentconfig', Campaign: null, SMS: '/sms', Email: '/email', Whatsapp: '/whatsapp', 'HR Management': null, Payroll: '/payroll',
  'Employee Leave': '/employeeleave', Holidays: '/holidays', Attendance: '/attendance', Payout: '/payouts', Payouts: '/payouts', SellerPayout: '/payouts', 'Seller Payout': '/payouts',
};

export const pathOf = (name) => (ROUTES[name] !== undefined ? ROUTES[name] : `/${name.toLowerCase().replace(/\s+/g, '')}`);

export const label = (n) => (n === 'Seller Payout' || n === 'SellerPayout' ? 'Payouts' : n);

// the signed-in seller as the app stores it
export const readStoredUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem('user') || localStorage.getItem('sellerUser') || localStorage.getItem('loginData') || 'null');
  } catch {
    return null;
  }
};
